// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ReRx","separator":"e8kGb"};